import { render, staticRenderFns } from "./BoxHeader.vue?vue&type=template&id=4da5a9de&scoped=true&lang=pug&"
var script = {}
import style0 from "./BoxHeader.vue?vue&type=style&index=0&id=4da5a9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da5a9de",
  null
  
)

export default component.exports